'use strict';
window.addEventListener('DOMContentLoaded', () => {
    let currentUrl = location.href;
    // リダイレクトの処理を追加
    if (currentUrl === `${window.location.origin}/search?q=`) {
        window.location.href = '/collections/lighting';
        return; // リダイレクト後に以下の処理を実行しない
    }

    document.getElementById("js-searchBnr").classList.add("js-open");
    // if (currentUrl.includes("tag:catCeiling")) {
    //     document.getElementById("js-collSearchBnr--ceiling").classList.add("js-open");
    // } else if (currentUrl.includes("tag:catPendant")) {
    //     document.getElementById("js-collSearchBnr--pendant").classList.add("js-open");
    // } else if (currentUrl.includes("tag:catSpot")) {
    //     document.getElementById("js-collSearchBnr--spotlight").classList.add("js-open");
    // } else if (currentUrl.includes("tag:catFloor")) {
    //     document.getElementById("js-collSearchBnr--floor-light").classList.add("js-open");
    // } else if (currentUrl.includes("tag:catDeskLight")) {
    //     document.getElementById("js-collSearchBnr--desk-light").classList.add("js-open");
    // } else if (currentUrl.includes("tag:catBracket")) {
    //     document.getElementById("js-collSearchBnr--bracket-light").classList.add("js-open");
    // } else if (currentUrl.includes("tag:catSmall")) {
    //     document.getElementById("js-collSearchBnr--small-space").classList.add("js-open");
    // } else if (currentUrl.includes("tag:catOutdoor")) {
    //     document.getElementById("js-collSearchBnr--outdoor-light").classList.add("js-open");
    // } else if (currentUrl.includes("tag:catCustom")) {
    //     document.getElementById("js-collSearchBnr--custom-lighting").classList.add("js-open");
    // } else if (currentUrl.includes("tag:catBulb")) {
    //     document.getElementById("js-collSearchBnr--light-bulb").classList.add("js-open");
    // } else if (currentUrl.includes("tag:catAccessories")) {
    //     document.getElementById("js-collSearchBnr--lighting-accessories").classList.add("js-open");
    // } else if (currentUrl.includes("tag:catClock")) {
    //     document.getElementById("js-collSearchBnr--clock").classList.add("js-open");
    // } else if (currentUrl.includes("tag:catStorage")) {
    //     document.getElementById("js-collSearchBnr--storage").classList.add("js-open");
    // } else if (currentUrl.includes("tag:catDeskChair")) {
    //     document.getElementById("js-collSearchBnr--desk-chair").classList.add("js-open");
    // } else {
    //     document.getElementById("js-searchBnr").classList.add("js-open");
    // }

    // window.dispatchEvent(new Event('collSearchBnrOpened'));

    render_default_conditions();
    render_search_labels();

    let searchConditionsAll = document.querySelectorAll(".js-searchConditions__list__btn");
    searchConditionsAll.forEach(function (searchConditions) {
        searchConditions.addEventListener("click", function () {
            let currentParameter = location.search;
            const stringToRemove = decodeURIComponent(searchConditions.getAttribute("data-parameter").trim());
            const params = new URLSearchParams(currentParameter);
            let newQuery = params.get('q') || '';

            newQuery = newQuery.replace(new RegExp(`(${stringToRemove}|${encodeURIComponent(stringToRemove)})`, 'g'), '').replace(/AND\s+/g, 'AND').trim();
            newQuery = newQuery.replace(/^AND\s+|AND\s+$/g, '');

            if (newQuery) {
                params.set('q', newQuery);
            } else {
                params.delete('q');
            }

            if (stringToRemove.includes('filter.v.price.gte')) {
                params.delete('filter.v.price.gte');
            }
            if (stringToRemove.includes('filter.v.price.lte')) {
                params.delete('filter.v.price.lte');
            }

            const newUrl = `${window.location.pathname}?${params.toString()}`;
            window.location.href = newUrl;
        });
    });

    const params = new URLSearchParams(window.location.search);
    if (!params.has('q') || params.get('q').trim() === '') {
        document.querySelector('.template-search__search').innerHTML = '<p role="status">検索条件の商品はありませんでした。</p>';
    }

    const searchInput = document.querySelector('.js-search-keyword');
    if (params.has('q')) {
        let keyword = params.get('q').replace(/tag:[^ ]+/g, '').trim();
        searchInput.value = keyword;
    }
});

function render_default_conditions() {
    let target_forms = [];
    let currentParameter = location.search;
    target_forms.push(document.querySelector('.js-headerSearch__modal'));
    target_forms.push(document.querySelector('.js-searchModal'));
    target_forms.push(document.querySelector('.js-searchSidebar'));

    let kw = '';
    if (currentParameter.indexOf('type=product&q=tag:') >= 0) {
        kw = '';
    } else {
        kw = decodeURIComponent(currentParameter.split('q=')[1].split('AND')[0].replace(/\+/g, ' '));
    }

    for (let form of target_forms) {
        if (kw !== '') {
            form.querySelector('.js-search-keyword').setAttribute('value', kw);
        }

        let form_items = form.querySelectorAll('.js-search-item');
        for (let el of form_items) {
            let cond_tag = el.getAttribute('data-tag');
            if (currentParameter.indexOf(cond_tag) >= 0) {
                el.checked = true;
            }

            if (el.getAttribute('data-category') === 'basetag') {
                console.log(el.getAttribute('data-tag'));
            }
        }
    }
}

function render_search_labels() {
    let html = '';
    let tags = get_tags();
    let currentParameter = location.search;
    let kw = '';
    if (currentParameter.indexOf('type=product&q=tag:') >= 0) {
        kw = '';
    } else {
        if (currentParameter.includes("type=product&q=")) {
            kw = decodeURIComponent(currentParameter.split('type=product&q=')[1].split('AND')[0].replace(/\+/g, ' '));
        } else {
            kw = decodeURIComponent(currentParameter.split('q=')[1].replace(/\+/g, ' '));
        }
        if (currentParameter.includes('product&q=')) {
            const deleteStr = currentParameter.match(/product&q=(.*?)(?=tag:)/);
            if (deleteStr && deleteStr[1].trim() !== '') {
                html += '<li class="js-searchConditions__list__btn searchConditions__list__btn" data-parameter="' + deleteStr[1] + '">' + kw + '</li>';
            }
        } else if (kw.trim() !== '') {
            html += '<li class="js-searchConditions__list__btn searchConditions__list__btn" data-parameter="' + kw + '">' + kw + '</li>';
        }
    }
    for (let tag in tags) {
        if (currentParameter.indexOf(tag) >= 0) {
            const searchValue = tags[tag];
            const matchingProperty = Object.keys(tags).find(key => tags[key] === searchValue);
            if (currentParameter.includes(matchingProperty + '%20OR%20')) {
                html += '<li class="js-searchConditions__list__btn searchConditions__list__btn" data-parameter="tag:' + matchingProperty + '%20OR%20">' + tags[tag] + '</li>';
            } else {
                html += '<li class="js-searchConditions__list__btn searchConditions__list__btn" data-parameter="tag:' + matchingProperty + '%20">' + tags[tag] + '</li>';
            }
        }
    }
    if (currentParameter.indexOf('filter.v.price.gte=') >= 0) {
        let gte = currentParameter.split('filter.v.price.gte=')[1].split('&')[0];
        html += '<li class="js-searchConditions__list__btn searchConditions__list__btn" data-parameter="filter.v.price.gte=' + gte + '">' + gte + '円〜</li>';
    }
    if (currentParameter.indexOf('filter.v.price.lte=') >= 0) {
        let lte = currentParameter.split('filter.v.price.lte=')[1].split('&')[0];
        html += '<li class="js-searchConditions__list__btn searchConditions__list__btn" data-parameter="filter.v.price.lte=' + lte + '">〜' + lte + '円</li>';
    }
    if (html !== '') {
        html = '<ul class="searchConditions__list">' + html + '</ul>';
    }
    let target_conditions = document.getElementById('js-searchConditions');
    target_conditions.innerHTML = html;

    // 空白や不要なラベルを除外する
    let conditionLabels = document.querySelectorAll('.js-searchConditions__list__btn');
    conditionLabels.forEach(label => {
        if (!label.textContent.trim()) {
            label.remove();
        }
    });
}

function get_tags() {
    let tags = {
        "catLighting": "すべての照明",
        "catCeiling": "シーリングライト",
        "catPendant": "ペンダントライト",
        "catSpot": "スポットライト / ミニシーリング",
        "catFloor": "フロアライト",
        "catDeskLight": "デスクライト / テーブルランプ",
        "catBracket": "ブラケットライト / ウォールライト",
        "catSmall": "小スペース",
        "catOutdoor": "屋外照明",
        "catCustom": "カスタムパーツ",
        "catBulb": "電球",
        "catAccessories": "照明アクセサリー / その他",
        "catFurniture": "すべての家具・インテリア",
        "catClock": "時計",
        "catStorage": "ストレージ",
        "catDeskChair": "デスク&チェア",
        "catCatalog": "カタログ",
        "catOther": "その他カテゴリ",
        "dim_lighting_led": "調光機能付き照明（LED内蔵）",
        "dim_lighting_bulb": "調光機能付き照明（対象の電球と併用）",
        "dim_lighting_smartBulb": "スマート電球に対応した照明",
        "dim_lighting_dimmer": "調光器に対応した照明",
        "dim_bulbE17_dimmer": "調光に対応したLED電球(E17)",
        "dim_bulbE26_dimmer": "調光に対応したLED電球(E26)",
        "sceneLiving": "リビング",
        "sceneDining": "ダイニング",
        "sceneWork": "ワークスペース",
        "scene1R1LDK": "1R / 1LDK",
        "sceneBed": "ベッドルーム",
        "sceneKids": "キッズルーム",
        "sceneSmall": "小スペース（エントランス、廊下など）",
        "sceneOther": "その他シーン",
        "tasteModern": "モダン",
        "tasteMidCentury": "ミッドセンチュリー",
        "tasteNatural": "ナチュラル",
        "tasteNordic": "北欧",
        "tasteClassic": "クラシック",
        "tasteVintage": "ヴィンテージ / インダストリアル",
        "tasteOffice": "オフィス",
        "tasteCafe": "カフェ",
        "tasteOther": "その他テイスト",
        "seriesGlow": "Glow",
        "seriesGrid": "Grid",
        "seriesBliss": "Bliss",
        "seriesEspresso": "Espresso",
        "seriesHerisson": "Herisson Natural",
        "seriesVintage": "Vintage",
        "colorBlack": "ブラック",
        "colorWhite": "ホワイト",
        "colorGraySilver": "グレー / シルバー",
        "colorGold": "ゴールド",
        "colorClear": "クリア",
        "colorWoodBrown": "ウッド / ブラウン",
        "colorOther": "その他カラー"
    };
    return tags;
}

window.addEventListener('load', () => {
    let searchConditionsAll = document.querySelectorAll(".js-searchConditions__list__btn");
    searchConditionsAll.forEach(function (searchConditions) {
        searchConditions.addEventListener("click", function () {
            let currentParameter = location.search;
            let currentUrl = window.location.href;
            const stringToRemove = searchConditions.getAttribute("data-parameter");
            const encodedStringToRemove = encodeURIComponent(stringToRemove).replace(/%20/g, '+');
            const newUrl = currentUrl.replace(new RegExp(encodedStringToRemove, 'g'), "").replace(new RegExp(stringToRemove, 'g'), "");

            window.location.href = newUrl.replace(/&$/, '');
        });
    });
});
